// Event URLs are meant to carry the event's slug (/event/sajam-2026), but
// some links can only know its id: notifications, a user's events list, the
// /person/:id redirect, old bookmarks. Once the event page has the event,
// this swaps the id for the slug in the address bar.
//
// It rewrites the current history entry directly instead of navigate():
// a router navigation would change the route param and make the event page
// reset and refetch everything it just loaded. The router's own state object
// is kept, so back/forward still work.
export const replaceEventIdWithSlug = (routeParam, slug) => {
  if (!routeParam || !slug || routeParam === slug) return;

  const { pathname, search, hash } = window.location;
  const prefix = pathname.startsWith("/events/") ? "/events/" : "/event/";
  const from = `${prefix}${routeParam}`;
  if (!pathname.startsWith(from)) return;

  const next = `${prefix}${slug}${pathname.slice(from.length)}${search}${hash}`;
  window.history.replaceState(window.history.state, "", next);
};
